import { createSelector } from 'reselect';

import { RootState } from '..';

export const selectUi = (state: RootState) => {
  return state.ui;
};

export const selectIsShowPreloader = createSelector(selectUi, (ui) => {
  return ui.isShowPreloader;
});

export const selectInfoPopup = createSelector(selectUi, (ui) => {
  return ui.isShowInfoPopup;
});
